import React from "react";
import { clsx } from "clsx";
import { LoadingSpinner } from "./LoadingSpinner";

interface LoadingOverlayProps {
  className?: string;
  spinnerSize?: "sm" | "md" | "lg";
  text?: string;
  fullScreen?: boolean;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  className,
  spinnerSize = "lg",
  text,
  fullScreen = false,
}) => {
  return (
    <div
      className={clsx(
        "flex items-center justify-center bg-white/80 backdrop-blur-sm z-50",
        fullScreen ? "fixed inset-0" : "absolute inset-0",
        className,
      )}
      data-testid="loading-overlay"
    >
      <LoadingSpinner size={spinnerSize} text={text} />
    </div>
  );
};

export { LoadingOverlay };
export type { LoadingOverlayProps };
